import { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import HeaderBar from "../../../Components/UI/headerbar";
import Button from "../../../Components/UI/buttonGlobal";
import LoadingSpinner from "../../../Components/UI/spinner";

import UserEdit from "../../../Components/users/editUser";

import { showUser, updateUser } from "../../../MyApi/user";

const UserEditPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formErrors, setFormErrors] = useState({});

  const [userInfo, setUserInfo] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    phone_code: "+20",
    avatar: null,
    status: "active",
    balance: 0,
    // loyalty_points: 0,
    // available_loyalty_points: 0,
    // points_expire_at: "",
    // order_count: 0,
  });

  const { data, isLoading } = useQuery(["showUser", id], () => showUser(id), {
    enabled: !!id,
  });

  useEffect(() => {
    if (data?.data?.user) {
      const user = data.data.user;

      setUserInfo({
        first_name: user.first_name || "",
        last_name: user.last_name || "",
        email: user.email || "",
        phone: user.phone || "",
        phone_code: user.phone_code || "+20",
        avatar: user.avatar || null,
        status: user.status || "active",
        balance: user.balance || 0,
        // loyalty_points: user.loyalty_points || 0,
        // available_loyalty_points: user.available_loyalty_points || 0,
        // points_expire_at: user.points_expire_at || "",
        // order_count: user.order_count || 0,
      });
    }
  }, [data]);

  const updateMutation = useMutation({
    mutationKey: ["updateUser"],

    mutationFn: (postData) => updateUser(postData, id),

    onSuccess: (data) => {
      toast.success(data.message);

      navigate(`${process.env.PUBLIC_URL}/users`);
    },

    onError: (error) => {
      toast.error(error?.response?.data?.message || "حدث خطأ");

      setFormErrors(error?.response?.data?.errors || {});
    },
  });

  const handleSubmit = () => {
    const formData = new FormData();

    formData.append("_method", "PUT");
    formData.append("first_name", userInfo.first_name);
    formData.append("last_name", userInfo.last_name);
    formData.append("email", userInfo.email);
    formData.append("phone", userInfo.phone);
    formData.append("phone_code", userInfo.phone_code);
    formData.append("status", userInfo.status);
    formData.append("balance", userInfo.balance);
    // formData.append("loyalty_points", userInfo.loyalty_points);
    // formData.append("available_loyalty_points", userInfo.available_loyalty_points,);
    // formData.append("points_expire_at", userInfo.points_expire_at);
    // formData.append("order_count", userInfo.order_count);
    if (userInfo.avatar instanceof File) {
      formData.append("avatar", userInfo.avatar);
    }

    updateMutation.mutate(formData);
  };

  if (isLoading) return <LoadingSpinner />;

  return (
    <div>
      <HeaderBar
        title="تعديل العميل"
        content="تعديل بيانات العميل"
        isBack={true}
      />

      <div className="container">
        <div className="card rounded-4">
          <div className="card-body">
            <UserEdit
              userInfo={userInfo}
              setUserInfo={setUserInfo}
              formErrors={formErrors}
            />

            <div className="mt-4 d-flex justify-content-end">
              <button
                className="btn btn-primary px-5"
                onClick={handleSubmit}
                disabled={updateMutation.isLoading}
              >
                {updateMutation.isLoading ? "جاري الحفظ..." : "حفظ التعديلات"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserEditPage;
